import axios from "axios";

const BASE_URL = process.env.REACT_APP_SONGS_URL;

export default async function getSong(audioId) {
    try {
        const response = await axios.get(`${BASE_URL}/getSong`, {
            params: {
                audioId: audioId,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching song data:', error);
        throw error;
    }
}